import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  colors,
} from "@mui/material";

import React, { useEffect, useState } from "react";

//table
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

//table end
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import Leo from "./../../assets/images/Leo.png";
import restaurant from "./../../assets/images/Restaurant.jpg";
import resBlack from "./../../assets/icons/restaurantBlack.png";
import productBlack from "./../../assets/icons/product (1).png";
import empBlack from "./../../assets/icons/Emp.png";
import menu from "./../../assets/images/Menu.png";
import "./LandingPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import restaurantIcon from "./../../assets/icons/restaurantBlack.png";
import menu3 from "./../../assets/icons/menu.png";
import order from "./../../assets/icons/cargo.png";
import communication from "../../assets/images/message.png";
import loyalty from "../../assets/images/loyal-customer.png";
import orderHistory from "./../../assets/icons/order-history.png";
import delivery from "./../../assets/icons/delivery.png";
import settings from "./../../assets/icons/settings.png";
import item from "./../../assets/icons/Item.png";
import SideBar from "../layouts/sidebar/SideBar.tsx";
import TopHeader from "../../components/TopHeader.tsx";
import AutoCompleteMultiSelect from "../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { NotificationState } from "../../reduxadmin/Reducers/Interface/Interface.tsx";
import NavigationCard from "./components/NavigationCard.tsx";
import {
  setupNotification,
  waitForServiceWorker,
} from "../../services/PwaService.tsx";
import IPadInstallToast from "../components/IpadPrompt/IPadInstallPrompt.tsx";
import { toast } from "react-toastify";
import LoadingView from "../components/LoadingView/LoadingView.js";

type Anchor = "top" | "left" | "bottom" | "right";

//table start
interface Column {
  id: "orderid" | "customername" | "foodname" | "quantity" | "price" | "button";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "orderid", label: "OrderId", minWidth: 100 },
  { id: "customername", label: "CutomerName", minWidth: 100 },
  {
    id: "foodname",
    label: "FoodName",
    minWidth: 170,
    align: "right",
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: "quantity",
    label: "Quantity",
    minWidth: 100,
    align: "right",
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: "price",
    label: "Price",
    minWidth: 100,
    align: "right",
    // format: (value: number) => value.toFixed(2),
  },
  { id: "button", label: "Action", minWidth: 170 },
];

// interface Data {
//   orderid: string;
//   customername: string;
//   foodname: number;
//   quantity: number;
//   price: number;
//   button:any
// }

function createData(
  orderid: string,
  customername: string,
  foodname: string,
  quantity: number,
  price: number,
) {
  return { orderid, customername, foodname, quantity, price };
}

const rows = [
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
  createData("B10101", "Leo", "Burger", 3, 1500),
];

//table end

function LandingPage() {
  const apiAddress = process.env.REACT_APP_SECRET;
  const location = useLocation();

  const [userPlanId, setUserPlanId] = useState(() => {
    const storedData = localStorage.getItem("restaurant");

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);

        return parsedData.FMlYe6C ? Number(parsedData.FMlYe6C) : 0;
      } catch (error) {
        console.error("JSON parsing error:", error);
        return 0;
      }
    }
    return 0;
  });

  const fromRef = React.useRef(location.state?.from?.pathname);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState((prevState) => ({
        ...prevState,
        [anchor]: !prevState[anchor],
      }));
    };
  const navigate = useNavigate();
  const clickMenuList = (props) => {
    console.log("props: " + props);
    if (props === "Manage restaurant") {
      navigate("/restaurant-setup");
    } else if (props === "Manage Product") {
      navigate("/manage-product");
    }
  };

  //table start

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //table end

  //for notification
  const dispatch = useDispatch();
  const total_notification = useSelector(
    (state: NotificationState) => state.totalNotification.totalNotification,
  );

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if ((reason && reason == "backdropClick") || reason == "escapeKeyDown")
      return;
    setOpen(false);
  };

  const getUserRolesInfo = async (userId, restaurantId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions?userId=${userId}&restaurantId=${restaurantId}`,
    );
    console.log("test6", response);
    return response.data;
  };

  // get screens by subscription plan
  const getScreensByPlanId = async (planId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllScreensByPlanId/${planId}`,
      );
      // console.log("Screens by Plan ID:", response.data);
      return response.data; // The API returns an array of strings directly
    } catch (error) {
      console.error("Error fetching screens by plan ID:", error);
      toast.error("Failed to load screen permissions."); // Optional: Show a user-friendly error
      return []; // Return an empty array on error to prevent breaking the UI
    }
  };

  const [loading, setLoading] = useState(false);

  async function SetupPushNotification() {
    const token = localStorage.getItem("gotasteadmintoken");

    if (!token) return;

    try {
      const decodedData = jwt_decode(token);

      console.log("Decoded JWT Data:", decodedData);

      setUserId(decodedData.UserId);
      setUserRole(decodedData.UserRole);

      // Wait for service worker (Brave/Opera fix)
      await waitForServiceWorker();

      // Subscribe for notifications
      await setupNotification(decodedData.UserId, decodedData.RestaurantId);
    } catch (error) {
      console.error("Error decoding JWT:", error);
    }
  }

  const addRestaurant = async (props, list) => {
    setLoading(true);

    const parentRestaurantStr = localStorage.getItem("parentrestaurant");
    let parentRestaurant = null;

    if (parentRestaurantStr) {
      try {
        parentRestaurant = JSON.parse(parentRestaurantStr);
      } catch (e) {
        console.warn("Failed to parse parentrestaurant", e);
      }
    }

    const selectedRestaurant = list.find((data) => data.title === props);

    if (!selectedRestaurant) {
      console.error("Restaurant not found:", props);
      setLoading(false);
      return;
    }

    const newObj = {
      id: selectedRestaurant.id,
      name: selectedRestaurant.title,
      imgUrl: selectedRestaurant.imgUrl,
      ulsHLfS: selectedRestaurant.isHomeCook,
      VSXnjMD: selectedRestaurant.isPreview,
      FMlYe6C: selectedRestaurant.subsPlan,
    };
    localStorage.setItem("parentrestaurant", JSON.stringify(newObj));
    localStorage.setItem("restaurant", JSON.stringify(newObj));
    localStorage.setItem("restaurantChanged", "newRestaurantSelected");

    try {
      const permissionData = await getUserRolesInfo(userid, newObj.id);
      localStorage.setItem("permissions", JSON.stringify(permissionData));
    } catch (err) {
      console.error("Permission fetch failed", err);
    }

    await handlePWA();

    setOpen(false);
    setLoading(false);
  };

  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const handlePWA = async () => {
    toast.info("Setting up notifications...");
    if (restaurantList.length > 0) {
      await SetupPushNotification().then(() => {
        const broadcastChannel = new BroadcastChannel("storage_change_channel");
        broadcastChannel.postMessage("restaurantChanged");
        window.dispatchEvent(new Event("storage"));
        setOpen(false);
        setLoading(false);
      });
    } else {
      setShowPermissionModal(true);
      setOpen(false);
      setLoading(false);
    }
  };

  const permission = localStorage.getItem("permissions");

  console.log("permission", permission);

  // useEffect(()=>{

  // })
  const [userid, setUserId] = useState("");
  const [userRole, setUserRole] = useState("");
  const [restaurantList, setRestaurantList] = useState([]);
  const [screensByPlan, setScreensByPlan] = useState([]);

  console.log("decodedData", userRole, userid);
  console.log("test3", restaurantList);

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        console.log(decodedData.UserId);
        setUserId(decodedData.UserId);
        setUserRole(decodedData.UserRole);
        console.log(userid);

        // call API to get screens by plan ID
        const fetchScreens = async () => {
          const screens = await getScreensByPlanId(userPlanId);

          setScreensByPlan(screens);

          if (screens && screens.length > 0) {
            localStorage.setItem("userScreens", JSON.stringify(screens));
          } else {
            localStorage.removeItem("userScreens");
          }
        };
        fetchScreens();

        // console.log("T123", screensByPlan);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    const Restauranttoken = localStorage.getItem("restaurant");
    console.log(Restauranttoken);
    if (Restauranttoken) {
      setOpen(false);
    } else {
      axios
        .get(
          apiAddress +
            "/api/RestaurantUserMapper/getbyuserid/" +
            decodedData.UserId,
        )
        .then(async (response) => {
          console.log(response.data);
          if (response.data.length > 0) {
            setOpen(true);
            var list = [];
            response.data.map((dt, i) => {
              var obj = {
                id: dt.restaurantId,
                title: dt.restaurantName,
                imgUrl: dt.imgUrl,
                img: dt.imgUrl,
                isHomeCook: dt.isHomeCookToggle,
                isPreview: dt.isPreview,
                subsPlan: dt.subsPlan,
              };
              list.push(obj);
            });
            setRestaurantList(list);
            console.log("response.data", response.data);
            if (response.data.length == 1) {
              await addRestaurant(response.data[0].restaurantName, list);
            }
          } else {
            var obj = {
              id: response.data[0].restaurantId,
              name: response.data[0].restaurantName,
              imgUrl: response.data[0].imgUrl,
              img: response.data[0].imgUrl,
              isHomeCook: response.data[0].isHomeCookToggle,
              isPreview: response.data[0].isPreview,
              subsPlan: response.data[0].subsPlan,
            };
            var list = [];
            list.push(obj);
            console.log("test4", obj);
            localStorage.setItem("restaurant", JSON.stringify(obj));
            // SetupPushNotification();
            await addRestaurant(response.data[0].restaurantName, list);
            setOpen(false);
          }
        });
    }
  }, []);

  // short-lived polling
  useEffect(() => {
    // Guard: Only poll if user is authenticated
    const token = localStorage.getItem("gotasteadmintoken");
    const parentRestaurant = localStorage.getItem("parentrestaurant");
    const currentRestaurant = localStorage.getItem("restaurant");

    if (!token || !currentRestaurant) return;

    let intervalId = null;
    let isStopped = false; // Prevent updates after unmount
    let isPolling = false; // Prevent overlapping API calls

    // Polling action: fetch & update "restaurant" in localStorage
    const pollRestaurant = async () => {
      if (isStopped || isPolling) return;

      isPolling = true;
      try {
        const decodedData = jwt_decode(token);
        const response = await axios.get(
          `${apiAddress}/api/RestaurantUserMapper/getbyuserid/${decodedData.UserId}`,
        );

        // Find the active restaurant (match by ID from current localStorage)
        const activeRestaurant = response.data?.find(
          (r) => r.restaurantId === JSON.parse(currentRestaurant).id,
        );

        if (activeRestaurant && !isStopped) {
          const updatedObj = {
            id: activeRestaurant.restaurantId,
            name: activeRestaurant.restaurantName,
            imgUrl: activeRestaurant.imgUrl,
            ulsHLfS: activeRestaurant.isHomeCook,
            VSXnjMD: activeRestaurant.isPreview,
            FMlYe6C: activeRestaurant.subsPlan,
          };

          // console.log("debug-upobj", updatedObj);

          if (JSON.parse(currentRestaurant).FMlYe6C !== updatedObj.FMlYe6C) {
            // Update "restaurant" key
            localStorage.setItem("restaurant", JSON.stringify(updatedObj));
            if (
              JSON.parse(currentRestaurant).id ===
              JSON.parse(parentRestaurant).id
            ) {
              localStorage.setItem(
                "parentrestaurant",
                JSON.stringify(updatedObj),
              );
            }
            // alert("Your subscription plan has been changed!");
            window.location.reload();
          }
        }
      } catch (error) {
        // Log but don't crash - polling continues on transient errors
        console.warn("Polling 'restaurant' failed (will retry):", error);

        // Stop on critical auth errors
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          stopPolling();
          localStorage.removeItem("gotasteadmintoken");
          window.location.href = "/login";
        }
      } finally {
        isPolling = false;
      }
    };

    // Helper: safely stop polling
    const stopPolling = () => {
      if (isStopped) return;
      isStopped = true;
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      console.log("Polling for 'restaurant' stopped");
    };

    // First poll runs immediately on mount
    pollRestaurant();

    // Then poll every 5 seconds indefinitely
    intervalId = setInterval(pollRestaurant, 5000);

    // Cleanup: stop polling when component unmounts
    return () => {
      stopPolling();
    };
  }, []); // Empty deps = run once on mount

  return (
    <>
      <LoadingView open={loading} close={() => setLoading(false)} />
      <TopHeader />
      <IPadInstallToast />
      <Dialog
        fullWidth={true}
        open={open && restaurantList.length > 1}
        onClose={handleClose}
      >
        <DialogTitle>
          <div className="d-flex justify-content-center align-items-center">
            Select your restaurant
          </div>
        </DialogTitle>
        <DialogContent>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ flexWrap: "wrap", gap: "20px" }}
          >
            {restaurantList.map((dt, i) => {
              return (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    flexDirection: "column",
                    borderRadius: "10px",
                    padding: "5px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    maxWidth: "10rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    addRestaurant(dt.title, restaurantList);
                  }}
                >
                  {dt.img == "" ? (
                    <img
                      src={restaurantIcon}
                      alt=""
                      style={{ width: "2rem" }}
                    />
                  ) : (
                    <img src={dt.img} alt="" style={{ width: "2rem" }} />
                  )}
                  <p className="pb-0 pt-1 mb-0">{dt.title}</p>
                </div>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Close</Button> */}
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={showPermissionModal}
        onClose={() => {}}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.35)", // gray transparent backdrop
            backdropFilter: "blur(2px)", // subtle blur effect (looks premium)
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: "18px",
            p: 1,
            background: "linear-gradient(135deg, #ffffff, #f7f9fc)",
            boxShadow: "0px 8px 30px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
          <h4
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "1.3rem",
              color: "#0b4f5d",
              letterSpacing: "0.3px",
            }}
          >
            Enable Notifications
          </h4>
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", pb: 0 }}>
          <p
            style={{
              margin: "0 auto",
              fontSize: "1rem",
              lineHeight: "1.6",
              maxWidth: "85%",
              color: "#455a64",
            }}
          >
            To receive real-time order updates, please tap the button below.
          </p>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            pt: 2,
            pb: 3,
          }}
        >
          <button
            style={{
              background: "linear-gradient(135deg, #0b4f5d, #06392f)",
              color: "white",
              padding: "10px 30px",
              fontSize: "1rem",
              border: "none",
              borderRadius: "12px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.25s ease",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0px)";
              e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
            }}
            onClick={async () => {
              setShowPermissionModal(false);
              // setLoading(true);

              await SetupPushNotification().then(() => {
                const broadcastChannel = new BroadcastChannel(
                  "storage_change_channel",
                );
                broadcastChannel.postMessage("restaurantChanged");
                window.dispatchEvent(new Event("storage"));
                setOpen(false);
                // setLoading(false);
              });
            }}
          >
            Continue
          </button>
        </DialogActions>
      </Dialog>

      <div className="row">
        <div className="col-2"></div>
        <div className="col-8 mt-3">
          <h2>Getting started</h2>
        </div>
        <div className="col-2"></div>
      </div>

      <div className="row">
        <div className="col-2"></div>
        <div className="col-8" style={{ marginTop: "2rem" }}>
          <div
            className="d-flex justify-content-center flex-wrap"
            style={{ gap: "10px" }}
          >
            <NavigationCard
              Icon={restaurantIcon}
              total_notification={total_notification}
              RedirectLocation={"/restaurant-setup"}
              Title={"Restaurant"}
              Description={"Manage , create, update restaurant here"}
              FooterText={"Create restaurant"}
              UsedFor="Restaurant"
            />

            <div
              className="discountImage cardGap mt-5"
              onClick={() => {
                window.location.href = "/manage-product";
              }}
            >
              {/* <img src={menu} alt="" className="img-fluid image-Discount" /> */}
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className="offer-Text">
                    {/* <h2><b>Create menu</b></h2> */}
                  </div>
                </div>
              </div>
              <div>
                <div className="CardTitle" style={{ right: "40%" }}>
                  <h5>Menu</h5>
                </div>
                <div className="CardDetails">
                  <p>Manage , create, update menu here</p>
                </div>
                <div className="iconPosition" style={{ top: "-18%" }}>
                  <div className="circle">
                    <img
                      src={menu3}
                      alt="icon"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center cardButton">
                  <h6>Create menu</h6>
                </div>
              </div>
            </div>

            <div
              className="discountImage mt-5"
              onClick={() => {
                window.location.href = "/orders";
              }}
            >
              {/* <img src={restaurant} alt="" className="img-fluid image-Discount" /> */}
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className="offer-Text">
                    {/* <h2><b>Create item</b></h2> */}
                  </div>
                </div>
              </div>
              <div
                className="CardTitle d-flex flex-row justify-content-center"
                style={{ width: "100%" }}
              >
                <h5>Kitchens</h5>
              </div>
              <div className="CardDetails">
                <p>Manage , and view kitchens here</p>
              </div>
              <div className="iconPosition" style={{ top: "-18%" }}>
                <div className="circle">
                  <img
                    src={order}
                    alt="icon"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center cardButton">
                <h6>Create item</h6>
              </div>
            </div>

            {/* loyalty */}
            <div
              className="discountImage mt-5"
              onClick={() => {
                // Only navigate if the plan allows it
                if (screensByPlan.includes("Loyalty")) {
                  window.location.href = "/loyalty-setup";
                } else {
                  toast.info(
                    "This feature is not available in your current plan.",
                  );
                }
              }}
              style={{
                // Apply disabled styles if not in screensByPlan
                opacity: screensByPlan.includes("Loyalty") ? 1 : 0.5,
                filter: screensByPlan.includes("Loyalty")
                  ? "none"
                  : "grayscale(1)",
                // pointerEvents: screensByPlan.includes("Loyalty")
                //   ? "auto"
                //   : "none",
                // cursor: screensByPlan.includes("Loyalty")
                //   ? "pointer"
                //   : "not-allowed",
              }}
            >
              {/* <img src={restaurant} alt="" className="img-fluid image-Discount" /> */}
              <div className="discountOfferDiv ">
                <div className="discountOfferDivDetails ">
                  <div className="offer-Text">
                    {/* <h2><b>Create item</b></h2> */}
                  </div>
                </div>
              </div>
              <div
                className="CardTitle d-flex flex-row justify-content-center"
                style={{ width: "100%" }}
              >
                <h5>Loyalty</h5>
              </div>
              <div className="CardDetails">
                <p>Manage , and view loyalty here</p>
              </div>
              <div className="iconPosition" style={{ top: "-18%" }}>
                <div className="circle">
                  <img
                    src={loyalty}
                    alt="icon"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center cardButton">
                <h6>Loyalty Scheme</h6>
              </div>
            </div>

            {/* marketing */}
            {userRole !== "Admin" && (
              <div
                className="discountImage mt-5"
                onClick={() => {
                  if (screensByPlan.includes("Marketing")) {
                    window.location.href = "/marketing";
                  } else {
                    toast.info(
                      "This feature is not available in your current plan.",
                    );
                  }
                }}
                style={{
                  // Apply disabled styles if not in screensByPlan
                  opacity: screensByPlan.includes("Loyalty") ? 1 : 0.5,
                  filter: screensByPlan.includes("Loyalty")
                    ? "none"
                    : "grayscale(1)",
                  // pointerEvents: screensByPlan.includes("Loyalty")
                  //   ? "auto"
                  //   : "none",
                  // cursor: screensByPlan.includes("Loyalty")
                  //   ? "pointer"
                  //   : "not-allowed",
                }}
              >
                {/* <img src={restaurant} alt="" className="img-fluid image-Discount" /> */}
                <div className="discountOfferDiv ">
                  <div className="discountOfferDivDetails ">
                    <div className="offer-Text">
                      {/* <h2><b>Create item</b></h2> */}
                    </div>
                  </div>
                </div>
                <div
                  className="CardTitle d-flex flex-row justify-content-center"
                  style={{ width: "100%" }}
                >
                  <h5>Marketing</h5>
                </div>
                <div className="CardDetails">
                  <p>Manage , and view marketing here</p>
                </div>
                <div className="iconPosition" style={{ top: "-18%" }}>
                  <div className="circle">
                    <img
                      src={communication}
                      alt="icon"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center cardButton">
                  <h6>Make Marketing</h6>
                </div>
              </div>
            )}

            <NavigationCard
              Icon={orderHistory}
              total_notification={total_notification}
              RedirectLocation={"/order-history-log"}
              Title={"Transactions Log"}
              Description={"Refund , Withdraw, Check transaction log here"}
              FooterText={"Refund, Withdraw & Statement"}
              UsedFor="OrderHistoryLog"
            />

            {userRole === "Admin" && (
              <>
                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-settings";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "36%" }}>
                    <h5>Delivery</h5>
                  </div>
                  <div className="CardDetails">
                    <p>Manage, and view delivery info here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={delivery}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-settings";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "26%" }}>
                    <h5>Company info</h5>
                  </div>
                  <div className="CardDetails">
                    <p>KYC, Registration, update merchant here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={item}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="discountImage mt-5"
                  onClick={() => {
                    window.location.href = "/admin-dashboard";
                  }}
                >
                  <div className="discountOfferDiv">
                    <div className="discountOfferDivDetails">
                      <div className="offer-Text"></div>
                    </div>
                  </div>
                  <div className="CardTitle" style={{ right: "26%" }}>
                    <h5>Settings for Leo</h5>
                  </div>
                  <div className="CardDetails">
                    <p>KYC, Registration, update merchant here</p>
                  </div>
                  <div className="iconPosition" style={{ top: "-18%" }}>
                    <div className="circle">
                      <img
                        src={settings}
                        alt="icon"
                        style={{ width: "3rem", height: "3rem" }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="col-2"></div>
      </div>
    </>
  );
}

export default LandingPage;
